import { clientGET } from 'api/client'
import { CombinedGame, Game, GameEvent, GameLineup, GamePresstext } from 'types'

const gameApiBase = '/sportdata/1'

export const getGame = async (id: string): Promise<{ data: Game }> => {
  return clientGET({
    url: gameApiBase + '/games/' + id
  })
}

export const getGameLineup = async (
  id: string
): Promise<{ data: GameLineup }> => {
  return clientGET({
    url: gameApiBase + '/games/' + id + '/lineup'
  })
}

export const getGameEvents = async (
  id: string
): Promise<{ data: GameEvent[] }> => {
  return clientGET({
    url: gameApiBase + '/games/' + id + '/events'
  })
}

export const getCombinedGame = async (
  id: string
): Promise<{ data: CombinedGame }> => {
  return clientGET({
    url: gameApiBase + '/games/' + id + '/combined'
  })
}

export const getGamePresstext = async (
  id: string
): Promise<{ data: GamePresstext }> => {
  return clientGET({
    url: gameApiBase + '/games/' + id + '/presstext'
  })
}
